// hooks/useChatRefs.js
import { useRef } from "react";

export const SWIPE_THRESHOLD = 60;
export const SWIPE_MAX = 120;

export function useChatRefs() {
  const fileInputRef = useRef(null);
  const startXRef = useRef(null);
  const longPressTimer = useRef(null);
  const longPressTriggered = useRef(false);
  const lastMoveRef = useRef(0);

  return {
    fileInputRef,
    startXRef,
    longPressTimer,
    longPressTriggered,
    lastMoveRef,
  };
}
